module.exports = __webpack_public_path__ + "resources/img/img-secuve-tos-02-m-en.ebc743c4fcad37c20647e013fe710d86.png";